dmx.Component('api-form', {
    extends: 'serverconnect-form'
});
